import React from 'react';
import UserCheckOutPreview from '../user-checkout-preview';

/*
 * El checkout anterior (components/user-checkout) se retiró: tanto
 * /user-checkout como /user-checkout-preview muestran siempre el nuevo, para
 * todos los usuarios y sin depender de ninguna consulta (antes, si la consulta
 * de acceso fallaba, se caía al checkout anterior).
 */
const UserCheckOutGate = props => <UserCheckOutPreview {...props} />;

export default UserCheckOutGate;
